import { v4 as uuid } from 'uuid';

/**
 * Local Import
 */
import { cleanCommand } from './utils';
import type { CommandProps } from './types';

/**
 * Spoiler command
 */
export const commandSpoiler = (props: CommandProps) => {
  const { addMessage, actions, chatId, context, value } = props;

  // Clean message without the `/commands`
  const cleanedCommand = cleanCommand({ command: 'spoiler', value });

  if (cleanedCommand === '') return false;

  const content = {
    ops: [{
      insert: cleanedCommand,
    }],
  };

  const payload = {
    chatId,
    content,
    context,
    isSpoiler: true,
    isCommand: true,
    messageUuid: uuid(),
  };

  // Send with `spoiler` option
  actions.sendMessage(payload);
  addMessage?.(payload);

  return true;
};
